import { render } from "./MultiFactorPhoneNumber.vue?vue&type=template&id=0554f983"
import script from "./MultiFactorPhoneNumber.vue?vue&type=script&lang=js"
export * from "./MultiFactorPhoneNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__